import { EStreamAllDataDTO } from './eStreamTrade';

export type InstrumentStoreItemDetails = {
  /** napi minimum */
  lowDaily: number;
  /** napi maximum */
  highDaily: number;
  /** átlagár */
  averagePrice: number;
  /** 10 napos átlagforgalom */
  avarage10DayVolume: number;
  /** 30 napos átlagforgalom */
  average30DayVolume: number;
  /** 3 hónapos átlagforgalom */
  average3MonthVolume: number;
  /** kötések száma */
  numberOfMoves: number;
  /** középár */
  middlePrice: number;
  /** Utolsó kötés ára USA pre-market időben */
  preMarketPrice: number | null;
  /** napi elmozdulás (nom) - calculated using market and current time */
  changeNominal?: number;
  /** napi elmozdulás ( % ) - calculated using market and current time */
  changePercentage?: number;
  /** napi elmozdulás (nom) - as defined in refinitiv*/
  changeNominalRaw?: number;
  /** napi elmozdulás (nom) - as stored in eStream */
  changeNominalPreviousRaw?: number;
  /** napi elmozdulás ( % ) - as defined in refinitiv */
  changePercentageRaw?: number;
  /** napi elmozdulás ( % ) - as stored in eStream */
  changePercentagePreviousRaw?: number;

  /** Utolsó indikatív ár BÉT piac nyitó és záró aukciós szakasz */
  betIndicativePrice: number;
  /** Forgalom (db) */
  volumeQuantity: number;
  /** Forgalom (nom.) */
  volumeNominal: number;
  /** 52 heti minimum */
  low52Week: number;
  /** 52 heti maximum */
  high52Week: number;
  /** 52 heti minimum dátuma */
  lowDate52Week?: string;
  /** 52 heti maximum dátuma */
  highDate52Week?: string;
  /** YTD árfolyam változás */
  yearToDateChange: number;
};

export type InstrumentStoreItemFundamentals = {
  /** piaci kapitalizáció */
  marketCap: number;
  /** EPS (TTM) */
  eps_ttm: number;
  /** P/BV (utolsó negyedév) */
  p_bv: number;
  /** P/E (TTM) */
  p_e_ttm: number;
  /** P/S (TTM) */
  p_s_ttm: number;
  /** Osztalék */
  dividend: number;
  /** Osztalékhozam */
  dividendYield: number;
  /** 5 éves osztalékhozam */
  dividendYield5YAvg: number;
  /** EBITDA (TTM) */
  ebitda_ttm: number;
  /** ROE (TTM) */
  roe_ttm: number;
  /** ROA (TTM) */
  roa_ttm: number;
};

export type InstrumentStoreItemOrderBook = {
  isAskMarketPrice?: boolean;
  isBidMarketPrice?: boolean;
  asks?: Array<[number, number]>;
  bids?: Array<[number, number]>;
};

export enum InstrumentStorePriceType {
  FromInstrumentService = 'FromInstrumentService',
  LastKnownPrice = 'LastKnownPrice',
  ClosePrice = 'ClosePrice',
  RealTimeUp = 'RealTimeUp',
  RealTimeDown = 'RealTimeDown',
  RealTimeNeutral = 'RealTimeNeutral',
  Delayed = 'Delayed',
  IndicativePrice = 'IndicativePrice',
  PolledPrice = 'PolledPrice',
}

export type InstrumentStorePrice = {
  type: InstrumentStorePriceType;
  value: number;
};

export type InstrumentStoreComplexBookData =
  | {
      isMarketPrice: true;
    }
  | {
      isMarketPrice: false;
      value?: number;
    };

/**
 * Internal NetBroker-web store's type for instrument data
 */
export type InstrumentStoreItem = {
  ric: string;
  /** piac */
  mic: string;
  /** Devizanem */
  ccy?: string;

  ticker?: string;
  /** előző záróár */
  closePrice?: number;
  /** nyitó ár */
  openPrice?: number;
  lastTradeTime?: Date;
  lastTradeQty?: number;

  bestBid?: InstrumentStoreComplexBookData;
  bestAsk?: InstrumentStoreComplexBookData;

  book?: InstrumentStoreItemOrderBook;

  exchangeId?: string;

  details?: Partial<InstrumentStoreItemDetails>;
  fundamentals?: Partial<InstrumentStoreItemFundamentals>;

  price?: InstrumentStorePrice;

  raw?: Partial<EStreamAllDataDTO>;
};
